import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/CQExportToExcel";
import { getCQDocReport } from "../../../store/Reports/actions";
import "../reports.scss";
class CQReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getCQDocReport(this.props.match.params.id);
  }

  render() {
   

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/cqreport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          HeaderHead={[].concat.apply(
                            [],
                            this.props.RFQCellData?.map((header, i) => {
                              if (i === 0) {
                                return [header.headerName, ""];
                              } else {
                                return [header.headerName, "", "", ""];
                              }
                            })
                          )}
                          Header={[].concat.apply(
                            [],
                            this.props.RFQCellData?.map((header, i) => {
                              if (i === 0) {
                                return ["Item Name", "Quantity"];
                              } else {
                                return [
                                  "Quantity",
                                  "Price",
                                  "Tax",
                                  "Gross Value",
                                ];
                              }
                            })
                          )}
                          apiData={this.props.CQbodyData.map((item, key) => {
                            var nexarr = this.props.RFQCellData?.map(
                              (header) => {
                                if (header.CellName !== "ItemName") {
                                  if (item[header.CellName]) {
                                    return [
                                      !item[header.CellName].Quotationcheck
                                        ? item[header.CellName].Quantity
                                        : item[header.CellName].Quantity +
                                          "\n Approved Qty " +
                                          item[header.CellName]
                                            .ApprovedQuantity,
                                      item[header.CellName].Price,
                                      item[header.CellName].tax +
                                        " %" +
                                        (item[header.CellName].taxtype === 1
                                          ? "Inclusive"
                                          : "Exclusive"),
                                      !item[header.CellName].Quotationcheck
                                        ? item[header.CellName].GrossValue
                                        : "Vendor Gross: " +
                                          item[header.CellName].GrossValue +
                                          "\n Approved Gross: " +
                                          item[header.CellName]
                                            .updateGrossValue,
                                    ];
                                  } else {
                                    return [
                                      "Not Submited",
                                      "Not Submited",
                                      "Not Submited",
                                      "Not Submited",
                                    ];
                                  }
                                } else {
                                  return [];
                                }
                              }
                            );
                            var nexarr2 = [].concat.apply([], nexarr);
                            return [
                              item.ItemName.Name,
                              item.ItemName.Quantity +
                                " " +
                                item.ItemName.Quantity_unit.name,
                              ...nexarr2,
                            ];
                          })}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "COMPARE QUOTATION REPORT",
                            "",
                          ]}
                          fileName="COMPARE_QUOTATION_REPORT"
                        />
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2 mb-0">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <p className="card-title-14 pt-2">
                          GSTIN : 37AAKCS3233N1ZX
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        COMPARE QUOTATION REPORT ON{" "}
                        {this.props.CompareQuotation.code}
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        // hover

                        className="mb-0 p-0 table-centered table-color-black"
                        id="table-to-xls"
                      >
                        <thead className="text-center">
                          <tr>
                            {this.props.RFQCellData?.map((header, i) => (
                              <th colSpan={i === 0 ? 2 : 4}>
                                {header.headerName}
                              </th>
                            ))}
                          </tr>
                          <tr className="bg-light border">
                            {this.props.RFQCellData?.map((header, i) => {
                              if (i === 0) {
                                return (
                                  <>
                                    <th>Item Name</th>
                                    <th>Quantity</th>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Tax</th>
                                    <th>Gross&nbsp;Value</th>
                                  </>
                                );
                              }
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.CQbodyData.map((item, key) => (
                            <tr key={key} className="text-center">
                              <td>{item.ItemName.Name}</td>
                              <td>
                                {item.ItemName.Quantity}
                                &nbsp;
                                {item.ItemName.Quantity_unit.name}
                              </td>

                              {this.props.RFQCellData?.map((header) => {
                                if (header.CellName !== "ItemName") {
                                  if (item[header.CellName]) {
                                    return (
                                      <>
                                        {!item[header.CellName]
                                          .Quotationcheck && (
                                          <>
                                            <td className="nowrap">
                                              {item[header.CellName].Quantity}
                                            </td>
                                          </>
                                        )}
                                        {item[header.CellName]
                                          .Quotationcheck && (
                                          <>
                                            <td className="nowrap">
                                              <tr>
                                                <td>
                                                  Vendor&nbsp;Qty:&nbsp;
                                                  {
                                                    item[header.CellName]
                                                      .Quantity
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  Approved&nbsp;Qty:&nbsp;
                                                  {
                                                    item[header.CellName]
                                                      .ApprovedQuantity
                                                  }
                                                </td>
                                              </tr>
                                            </td>
                                          </>
                                        )}
                                        <td>
                                          &#8377;&nbsp;
                                          {item[header.CellName].Price}
                                        </td>
                                        <td>
                                          {item[header.CellName].tax}
                                          {""}% (
                                          {item[header.CellName].taxtype === 1
                                            ? "Inclusive"
                                            : "Exclusive"}
                                          )
                                        </td>
                                        {!item[header.CellName]
                                          .Quotationcheck && (
                                          <>
                                            <td className="nowrap">
                                              &#8377;&nbsp;
                                              {item[header.CellName].GrossValue}
                                            </td>
                                          </>
                                        )}
                                        {item[header.CellName]
                                          .Quotationcheck && (
                                          <>
                                            <td className="nowrap">
                                              <tr>
                                                <td>
                                                  Vendor&nbsp;Gross:&nbsp;
                                                  &#8377;&nbsp;
                                                  {
                                                    item[header.CellName]
                                                      .GrossValue
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  Approved&nbsp;Gross:&nbsp;
                                                  &#8377;&nbsp;
                                                  {
                                                    item[header.CellName]
                                                      .updateGrossValue
                                                  }
                                                </td>
                                              </tr>
                                            </td>
                                          </>
                                        )}
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        <td colSpan={4}>
                                          <span>Not Submited</span>
                                        </td>
                                      </>
                                    );
                                  }
                                } else {
                                  return <></>;
                                }
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { CompareQuotation, RFQCellData, CQbodyData, CQBodyTCData } =
    state.reports;

  return {
    CompareQuotation,
    RFQCellData,
    CQbodyData,
    CQBodyTCData,
  };
};
export default connect(mapStatetoProps, {
  getCQDocReport,
})(CQReportList);
